import React from "react";
import { DateRangePicker } from "react-dates";
import { capitalize } from "lodash";

export default class DateRangeControl extends React.PureComponent {
  state = {
    focusedInput: null,
  };

  handleFocusChange(focusedInput) {
    const { onFocus, onBlur } = this.props;
    const { focusedInput: prevFocusedInput } = this.state;
    if (prevFocusedInput && !focusedInput) {
      onBlur && onBlur();
    } else if (!prevFocusedInput && focusedInput) {
      onFocus && onFocus();
    }
    this.setState({ focusedInput });
  }

  handleDatesChange({ startDate, endDate }) {
    this.props.onChange &&
      this.props.onChange([
        startDate && startDate.format(moment.RUBY_DATE_FORMAT),
        endDate && endDate.format(moment.RUBY_DATE_FORMAT),
      ]);
  }

  render() {
    const { name, onChange, value, readOnly, disabled, ...rest } = this.props;
    const { focusedInput } = this.state;
    const [startDate, endDate] = value !== null ? value : [null, null];
    return (
      <DateRangePicker
        startDateId={`${name}-startDate`}
        endDateId={`${name}-endDate`}
        startDatePlaceholderText={I18n.t("base.from")}
        endDatePlaceholderText={I18n.t("base.to")}
        startDate={startDate && moment(startDate, moment.RUBY_DATE_FORMAT)}
        endDate={endDate && moment(endDate, moment.RUBY_DATE_FORMAT)}
        onDatesChange={this.handleDatesChange.bind(this)}
        focusedInput={focusedInput}
        onFocusChange={this.handleFocusChange.bind(this)}
        disabled={readOnly || disabled}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/DateRange.jsx